import {BehaviorSubject} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import {toast} from '@px/helper/toast';
import {envUtil} from '@px/helper/env';
import {tpsApi} from '@px/api/tps';
import {authStatus$} from './auth';

export const orderBookPermCache$ = new BehaviorSubject(false);

if (envUtil.isTestNet) {
  authStatus$
    .pipe(
      filter((authStatus: AuthStatus) => authStatus === 'Login'),
      switchMap(loadPermData)
    )
    .subscribe();
}

async function loadPermData() {
  const {data, error} = await tpsApi.getOrderBookPerm();
  if (data) {
    orderBookPermCache$.next(data.orderBookPerm);
  }
  if (error) {
    toast.error(error);
  }
}
